import { IOfficeField } from '@pages/office/models/office-data.model';
import { RequiredValidator } from '../../validators/required.validator';
import { ControlErrorsMessagesOverridesRegistryModel } from './models/control-custom-errors.model';

export const DEFAULT_CONTROL_ERROR_MESSAGES = (officeField: IOfficeField): ControlErrorsMessagesOverridesRegistryModel => ({
  [RequiredValidator.errorKey]: () => `${officeField.VistaFormItem.ColumnName}: Value required`,
  ['maxlength']: ({ requiredLength }: { actualLength: number; requiredLength: number }) =>
    `${officeField.VistaFormItem.ColumnName}: Maximum length for this field is ${requiredLength}`,
});
